
import { DownloadButton } from "_components/buttons";
import { CustomTable } from "_components/table/CustomTable";
import { addOffRangeIndex } from "_helpers";
import { dataCollectorActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export { DatasTableBusDataCollector }


function DatasTableBusDataCollector ({dataCollector}) {

    const [data, setData] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if(dataCollector?.data) {
            const temp = addOffRangeIndex(dataCollector.data);
            //console.log('tmp', temp);
            setData(temp);            
        }
    }, [dataCollector]);

    useEffect(() => {
        return () => {            
            dispatch(dataCollectorActions.clearData());
        }
    }, [])

    const downloadHeaders = [
        { label: 'Date/heure', key: 'endOfSampling', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch1AtEnd_v01', key: 'BatteryStateOfChargeBranch1AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch2AtEnd_v01', key: 'BatteryStateOfChargeBranch2AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch3AtEnd_v01', key: 'BatteryStateOfChargeBranch3AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch4AtEnd_v01', key: 'BatteryStateOfChargeBranch4AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch5AtEnd_v01', key: 'BatteryStateOfChargeBranch5AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch6AtEnd_v01', key: 'BatteryStateOfChargeBranch6AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch7AtEnd_v01', key: 'BatteryStateOfChargeBranch7AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch8AtEnd_v01', key: 'BatteryStateOfChargeBranch8AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch9AtEnd_v01', key: 'BatteryStateOfChargeBranch9AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryStateOfChargeBranch10AtEnd_v01', key: 'BatteryStateOfChargeBranch10AtEnd_v01', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch1Max_v02', key: 'BatteryMaxCellTempBranch1Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch2Max_v02', key: 'BatteryMaxCellTempBranch2Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch3Max_v02', key: 'BatteryMaxCellTempBranch3Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch4Max_v02', key: 'BatteryMaxCellTempBranch4Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch5Max_v02', key: 'BatteryMaxCellTempBranch5Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch6Max_v02', key: 'BatteryMaxCellTempBranch6Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch7Max_v02', key: 'BatteryMaxCellTempBranch7Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch8Max_v02', key: 'BatteryMaxCellTempBranch8Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch9Max_v02', key: 'BatteryMaxCellTempBranch9Max_v02', type: 'string', visible: true },
        { label: 'BatteryMaxCellTempBranch10Max_v02', key: 'BatteryMaxCellTempBranch10Max_v02', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch1Delta_v01', key: 'BatteryCellVoltBranch1Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch2Delta_v01', key: 'BatteryCellVoltBranch2Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch3Delta_v01', key: 'BatteryCellVoltBranch3Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch4Delta_v01', key: 'BatteryCellVoltBranch4Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch5Delta_v01', key: 'BatteryCellVoltBranch5Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch6Delta_v01', key: 'BatteryCellVoltBranch6Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch7Delta_v01', key: 'BatteryCellVoltBranch7Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch8Delta_v01', key: 'BatteryCellVoltBranch8Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch9Delta_v01', key: 'BatteryCellVoltBranch9Delta_v01', type: 'string', visible: true },
        { label: 'BatteryCellVoltBranch10Delta_v01', key: 'BatteryCellVoltBranch10Delta_v01', type: 'string', visible: true },
    ];

    const headers = [
        {
            group: 'endOfSampling',
            children: [
                { label: 'Date/heure', key: 'endOfSampling', type: 'string', visible: true }
            ]
        },    
        {
            group: 'État de charge (BatteryStateOfCharge) (%)',
            children: [
                { label: 'Branche1', key: 'BatteryStateOfChargeBranch1AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche2', key: 'BatteryStateOfChargeBranch2AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche3', key: 'BatteryStateOfChargeBranch3AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche4', key: 'BatteryStateOfChargeBranch4AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche5', key: 'BatteryStateOfChargeBranch5AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche6', key: 'BatteryStateOfChargeBranch6AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche7', key: 'BatteryStateOfChargeBranch7AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche8', key: 'BatteryStateOfChargeBranch8AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche9', key: 'BatteryStateOfChargeBranch9AtEnd_v01', type: 'string', visible: true },
                { label: 'Branche10', key: 'BatteryStateOfChargeBranch10AtEnd_v01', type: 'string', visible: true },
            ]
        },    
        {
            group: 'Température max. des cellules (BatteryMaxCellTemp) (°C)',
            children: [
                { label: 'Branche1', key: 'BatteryMaxCellTempBranch1Max_v02', type: 'string', visible: true },
                { label: 'Branche2', key: 'BatteryMaxCellTempBranch2Max_v02', type: 'string', visible: true },
                { label: 'Branche3', key: 'BatteryMaxCellTempBranch3Max_v02', type: 'string', visible: true },
                { label: 'Branche4', key: 'BatteryMaxCellTempBranch4Max_v02', type: 'string', visible: true },
                { label: 'Branche5', key: 'BatteryMaxCellTempBranch5Max_v02', type: 'string', visible: true },
                { label: 'Branche6', key: 'BatteryMaxCellTempBranch6Max_v02', type: 'string', visible: true },
                { label: 'Branche7', key: 'BatteryMaxCellTempBranch7Max_v02', type: 'string', visible: true },
                { label: 'Branche8', key: 'BatteryMaxCellTempBranch8Max_v02', type: 'string', visible: true },
                { label: 'Branche9', key: 'BatteryMaxCellTempBranch9Max_v02', type: 'string', visible: true },
                { label: 'Branche10', key: 'BatteryMaxCellTempBranch10Max_v02', type: 'string', visible: true },
            ]
        },        
        {
            group: 'Delta de tension des cellules (BatteryCellVoltBranchXDelta) (mV)',
            children: [
                { label: 'Branche1', key: 'BatteryCellVoltBranch1Delta_v01', type: 'string', visible: true },
                { label: 'Branche2', key: 'BatteryCellVoltBranch2Delta_v01', type: 'string', visible: true },
                { label: 'Branche3', key: 'BatteryCellVoltBranch3Delta_v01', type: 'string', visible: true },
                { label: 'Branche4', key: 'BatteryCellVoltBranch4Delta_v01', type: 'string', visible: true },
                { label: 'Branche5', key: 'BatteryCellVoltBranch5Delta_v01', type: 'string', visible: true },
                { label: 'Branche6', key: 'BatteryCellVoltBranch6Delta_v01', type: 'string', visible: true },
                { label: 'Branche7', key: 'BatteryCellVoltBranch7Delta_v01', type: 'string', visible: true },
                { label: 'Branche8', key: 'BatteryCellVoltBranch8Delta_v01', type: 'string', visible: true },
                { label: 'Branche9', key: 'BatteryCellVoltBranch9Delta_v01', type: 'string', visible: true },
                { label: 'Branche10', key: 'BatteryCellVoltBranch10Delta_v01', type: 'string', visible: true },
            ]
        },
    ];
    
    return (
        <>
            {dataCollector && (
                <div className='custom-table-container' >
                    <div className={'flex justify-between items-end'}>
                        <div className="flex items-end">
                            <span className={'small-title-customtable mr-2 '}>
                                {data?.length ?? 0}                                
                            </span>
                            <i className="pb-0.5"> lignes issues de DataCollector</i>
                        </div>
                        <DownloadButton title={'Données Data Collector'} headers={downloadHeaders} data={data} />
                    </div>                    
                    <div className={"my-4 "}>                        
                        <CustomTable data={data} headers={headers} maxHeight={'65vh'} stickyFirstColumn={true}/>
                    </div>
                    
                </div>
            )}
        </>
    )    
}